import { render, staticRenderFns } from "./UserTransactionLinkQuery.vue?vue&type=template&id=7700f7c0&scoped=true&"
import script from "./UserTransactionLinkQuery.vue?vue&type=script&lang=js&"
export * from "./UserTransactionLinkQuery.vue?vue&type=script&lang=js&"
import style0 from "./UserTransactionLinkQuery.vue?vue&type=style&index=0&id=7700f7c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7700f7c0",
  null
  
)

export default component.exports